import { jsxs as c, jsx as r } from "react/jsx-runtime";
import { StampType as o } from "../../../../../components/CouponStamp/index.js";
import { Container as p } from "./styles.js";
import { useTranslation as l } from "../../../../../hooks/useTranslation/index.js";
const E = ({
  type: d = o.DISCOUNT_FIXED,
  value: i = 0,
  className: n
}) => {
  const { t: e } = l("common");
  return {
    [o.PRICE]: /* @__PURE__ */ c(p, { className: n, children: [
      /* @__PURE__ */ r("small", { children: e("deal-card-coupon-stamp-price") }),
      " ",
      i
    ] }),
    [o.DISCOUNT_PERCENTAGE]: /* @__PURE__ */ c(p, { className: n, children: [
      i,
      "% ",
      /* @__PURE__ */ r("small", { children: "OFF" })
    ] }),
    [o.DISCOUNT_FIXED]: /* @__PURE__ */ c(p, { className: n, children: [
      /* @__PURE__ */ r("small", { children: e("deal-card-coupon-stamp-price") }),
      " ",
      i,
      " ",
      /* @__PURE__ */ r("small", { children: "OFF" })
    ] }),
    [o.FREE_SHIPPING]: /* @__PURE__ */ r(p, { className: n, children: e("deal-card-coupon-stamp-free-shipping") }),
    [o.FREE]: /* @__PURE__ */ r(p, { className: n, children: e("deal-card-coupon-stamp-free") })
  }[d];
};
export {
  E as DealCardCouponStamp
};
